import axios, { AxiosError } from "axios";
const CustomerResource = {
    get(customerId, resultFunc, errorFunc, finallyFunc) {
        axios.get(`/admin/v1/customers/${customerId}`)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    getDeliveryInstructions(customerId, resultFunc, errorFunc, finallyFunc) {
        axios.get(`/admin/v1/customers/${customerId}/delivery-instructions`)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    create(request, resultFunc, errorFunc, finallyFunc) {
        axios.post(`/admin/v1/customers`, request)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    update(customerId, request, resultFunc, errorFunc, finallyFunc) {
        axios.put(`/admin/v1/customers/${customerId}`, request)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    linkDebtor(customerId, debtorId, resultFunc, errorFunc, finallyFunc) {
        const request = {
            debtorId
        };
        axios.post(`/admin/v1/customers/${customerId}/debtor`, request)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    unlinkDebtor(customerId, resultFunc, errorFunc, finallyFunc) {
        axios.delete(`/admin/v1/customers/${customerId}/debtor`)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    getDebtorNote(customerId, resultFunc, errorFunc, finallyFunc) {
        axios.get(`/admin/v1/customers/${customerId}/debtor/note`)
            .then((response) => {
            if (response.status === 204) {
                return resultFunc(null);
            }
            else if (response.status === 200) {
                return resultFunc(response.data ?? null);
            }
        })
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    getEffectivePriceList(customerId, geographicalAreaLatitude, geographicalAreaLongitude, resultFunc, errorFunc, finallyFunc) {
        const queryParams = {
            geographicalAreaLatitude,
            geographicalAreaLongitude
        };
        axios.get(`/admin/v1/customers/${customerId}/effective-price-list`, { params: queryParams })
            .then((response) => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    }
};
export default CustomerResource;
